export type AuthFailureReason =
  | 'session-expired'
  | 'invalid-token'
  | 'no-token'
  | 'unauthorized';

type AuthFailureSubscriber = (reason: AuthFailureReason) => void;

let handlingAuthFailure = false;
const subscribers = new Set<AuthFailureSubscriber>();

export function isAuthFailureActive(): boolean {
  return handlingAuthFailure;
}

export function onAuthFailure(cb: (reason: AuthFailureReason) => void): () => void {
  subscribers.add(cb);
  return () => {
    subscribers.delete(cb);
  };
}

export function triggerAuthFailure(reason: AuthFailureReason = 'unauthorized'): void {
  if (handlingAuthFailure) return;

  handlingAuthFailure = true;
  subscribers.forEach((subscriber) => {
    subscriber(reason);
  });

  // Allow future sessions to trigger again after the current burst is handled.
  window.setTimeout(() => {
    handlingAuthFailure = false;
  }, 1500);
}
